<div class="suggestion-cards" [ngClass]="gridColumnsClass">
  <div class="suggestion-card"
       *ngFor="let suggestion of suggestions; let i = index"
       (click)="onSuggestionClick(suggestion)">
    <span class="card-icon" aria-hidden="true">
      <svg *ngIf="iconFor(suggestion.title, i) === 'topics'" viewBox="0 0 24 24" fill="none">
        <path d="M8 7h11M8 12h11M8 17h11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        <circle cx="4.5" cy="7" r="1.2" fill="currentColor"/>
        <circle cx="4.5" cy="12" r="1.2" fill="currentColor"/>
        <circle cx="4.5" cy="17" r="1.2" fill="currentColor"/>
      </svg>
      <svg *ngIf="iconFor(suggestion.title, i) === 'cause'" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/>
        <circle cx="12" cy="12" r="7" stroke="currentColor" stroke-width="1.6"/>
        <path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
      <svg *ngIf="iconFor(suggestion.title, i) === 'sentiment'" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"/>
        <path d="M8.5 10.2h.01M15.5 10.2h.01" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M8.5 14c.8 1.2 2 1.8 3.5 1.8s2.7-.6 3.5-1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
      <svg *ngIf="iconFor(suggestion.title, i) === 'trend'" viewBox="0 0 24 24" fill="none">
        <path d="M4 16.5l5-5 3.2 3.2L20 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.5 7H20v5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg *ngIf="iconFor(suggestion.title, i) === 'report'" viewBox="0 0 24 24" fill="none">
        <path d="M7 3.5h7.2L19 8.2V20a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 6 20V5a1.5 1.5 0 0 1 1.5-1.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        <path d="M14 3.8V8h4.2M9 13h6M9 16.5h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
      <svg *ngIf="iconFor(suggestion.title, i) === 'chart'" viewBox="0 0 24 24" fill="none">
        <path d="M5 19V10M12 19V5M19 19v-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </span>
    <div class="card-content">
      <div class="card-title"
           #cardTitle
           [matTooltip]="suggestion.title"
           [matTooltipPosition]="'above'"
           [matTooltipClass]="'suggestion-card-tooltip'"
           [matTooltipDisabled]="!isCardTruncated(i)">{{ suggestion.title }}</div>
    </div>
    <span class="card-arrow" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>
</div>
